import React from 'react';
import { useRoleGuard } from 'shared/hooks/use-role-guard.ts';
import type { UserRole } from 'types/user.ts';

export { UserRole } from 'types/user.ts';

export function withRoleGuard<T>(WrappedComponent: React.FC<T>, allowedRoles: UserRole[]) {
  return (props: T) => {
    const isAllow = useRoleGuard(allowedRoles);

    if (!isAllow) return null;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <WrappedComponent {...props} />;
  };
}
